export const buttonRadiusStyles: Record<string, Record<string, string>> = {
  none: {
    'button-border-radius': '0rem'
  },
  rounded: {
    'button-border-radius': '0.25rem'
  },
  circle: {
    'button-border-radius': '2.5rem'
  }
};
